import { render, staticRenderFns } from "./ChartjsBarChartAgent.vue?vue&type=template&id=a4bc0480&"
import script from "./ChartjsBarChartAgent.vue?vue&type=script&lang=js&"
export * from "./ChartjsBarChartAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports